import type React from "react";
import styles from "./index.module.scss";

interface PageHeaderProps {
  title: string;
  titleActions?: React.ReactNode;
  children?: React.ReactNode;
  className?: string;
}

const PageHeader: React.FC<PageHeaderProps> = ({ title, titleActions, children, className }) => {
  return (
    <div className={`${styles["pageHeader"]} ${className || ""}`}>
      <div className={styles["pageHeader-inner"]}>
        <div className={styles["pageHeader-left"]}>
          <h1>{title}</h1>
          {titleActions}
        </div>
        {children && (
          <div className={styles["pageHeader-right"]}>
            <div className={styles["pageHeader-buttons"]}>{children}</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PageHeader;
